import { useNavigate, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  const navigate = useNavigate();

  const quickLinks = [
    { name: 'Watch Cat Videos', path: '/videos', icon: 'ri-play-circle-line', color: 'bg-teal-500 hover:bg-teal-600' },
    { name: 'Shop Products', path: '/shop', icon: 'ri-shopping-bag-3-line', color: 'bg-amber-500 hover:bg-amber-600' },
    { name: 'Adopt a Cat', path: '/adopt', icon: 'ri-heart-pulse-line', color: 'bg-rose-500 hover:bg-rose-600' },
    { name: 'Read Blog', path: '/blog', icon: 'ri-article-line', color: 'bg-purple-500 hover:bg-purple-600' },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-teal-50">
      <Navbar />
      
      <div className="pt-20 pb-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          {/* Cat Image */}
          <div className="mb-8">
            <img
              src="https://public.readdy.ai/ai/img_res/fa5d4312a9589fbc002ab53c7c562214.jpg"
              alt="Lost Cat"
              className="w-80 h-80 mx-auto rounded-full object-cover shadow-2xl border-8 border-white"
            />
          </div>
          
          {/* Error Message */}
          <h1 className="text-8xl md:text-9xl font-bold text-gray-800 mb-4">404</h1>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            Oops! This Cat Wandered Off 🐾
          </h2>
          <p className="text-lg md:text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Looks like this page got lost chasing a laser pointer. 
            Let's get you back to the good stuff!
          </p>
          
          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <button
              onClick={() => navigate('/')}
              className="bg-teal-500 text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-teal-600 transition-all duration-300 hover:scale-105 flex items-center justify-center gap-2 shadow-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-home-4-line text-xl"></i>
              Go Home
            </button>
            <button
              onClick={() => navigate(-1)}
              className="bg-white text-gray-700 px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all duration-300 hover:scale-105 flex items-center justify-center gap-2 shadow-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-arrow-left-line text-xl"></i>
              Go Back
            </button>
          </div>

          {/* Quick Links */}
          <div className="mt-12">
            <h3 className="text-xl font-bold text-gray-800 mb-6">Or explore these popular pages:</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {quickLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`${link.color} text-white p-6 rounded-2xl shadow-lg transition-all duration-300 hover:scale-105 hover:shadow-xl cursor-pointer`}
                >
                  <i className={`${link.icon} text-4xl mb-3 block`}></i>
                  <span className="font-bold text-lg">{link.name}</span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}